import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { container } from '@/app/container';
import { SalesRepositoryToken } from '../../di/tokens';

/**
 * Histórico paginado de eventos da transação (mais recentes primeiro). Usado no
 * modal de eventos — só dispara quando `enabled` (modal aberto).
 */
export function useTransactionEvents(
  transactionId: string,
  page: number,
  perPage: number,
  enabled = true,
) {
  const repository = container.resolve(SalesRepositoryToken);
  return useQuery({
    queryKey: ['sales', 'transaction', transactionId, 'events', page, perPage],
    queryFn: () =>
      repository.getTransactionEvents(transactionId, { page, perPage }),
    enabled: !!transactionId && enabled,
    staleTime: 1000 * 60 * 5,
    placeholderData: keepPreviousData,
    retry: false,
  });
}
